import _axios from '@/utils/request'
const feedbackServices = {
    // 意见反馈列表
    getFeedbackList (params) {
        return _axios('post', `/ms-shulan-hospital/v1/suggest/list`, params)
    },
    // 处理意见反馈
    answerFeedback (params) {
        return _axios('post', `/ms-shulan-hospital/v1/suggest/answer`, params)
    }
}

export default feedbackServices
